import React from "react"
import { Pagination } from "@cd2/components"

export function EOSPagination(props: Parameters<typeof Pagination>[0]) {
  // Pagination wont show if less than 20 (the default pagination number) but will still display
  // if the number per page has been changed
  if (props.maxPages < 2 && props.perPage === 20) {
    return null
  }
  return <Pagination {...props} />
}
